import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import DeleteIcon from '@material-ui/icons/Delete';
import _ from 'lodash';
import {connect} from "react-redux";
import {actions} from "../../actions";

const actionsStyles = theme => ({
    root: {
        flexShrink: 0,
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing.unit * 2.5,
    },
});

class TablePaginationActions extends React.Component {


    handleBackButtonClick = event => {
        this.props.onChangePage(event, this.props.page - 1);
    };

    handleNextButtonClick = event => {
        this.props.onChangePage(event, this.props.page + 1);
    };


    render() {
        const {classes, count, page, rowsPerPage, theme} = this.props;

        return (
            <div className={classes.root}>

                <IconButton
                    onClick={this.handleBackButtonClick}
                    disabled={page === 0}
                    aria-label="Previous Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowRight/> : <KeyboardArrowLeft/>}
                </IconButton>
                <IconButton
                    onClick={this.handleNextButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Next Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowLeft/> : <KeyboardArrowRight/>}
                </IconButton>

            </div>
        );
    }
}

TablePaginationActions.propTypes = {
    classes: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    theme: PropTypes.object.isRequired,
};

const TablePaginationActionsWrapped = withStyles(actionsStyles, {withTheme: true})(
    TablePaginationActions,
);

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
    },
    table: {
        minWidth: 500,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    button: {
        margin: theme.spacing.unit,
    }
});

class RubricsList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            rowsPerPage: 10
        };
    };

    handleChangePage = (event, page) => {
        this.setState({page}, () => {
            // let query = {
            //     unid: this.props.user.unid,
            //     page: page+1,
            //     limit: this.state.rowsPerPage
            // }
            // // this.props.fetchAssessments(query);
        });
    };

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.rubrics !== nextProps.rubrics;
    }

    handleChangeRowsPerPage = event => {
        // let query = {
        //     unid: this.props.user.unid,
        //     page: this.state.page+1,
        //     limit: event.target.value
        // }
        // this.props.fetchAssessments(query).then(()=>{
        //     this.setState({rowsPerPage: event.target.value})
        // });
    };

    componentDidMount() {
        //TODO: fetch list of assessments associated with user
        // let query = {
        //     unid: this.props.user.unid,
        //     page: this.state.page+1,
        //     limit: this.state.rowsPerPage
        // }
        // this.props.fetchAssessments(query);

    }

    renderRows(list) {
        if(list) {
            return _.map(list, row => {
                if(this.props.showActions) {
                    return (
                        <TableRow key={row._id}>
                            <TableCell style={{cursor: 'pointer'}} onClick={event => this.handleClick(event, row)}>{row.name}</TableCell>
                            <TableCell>{row.updatedAt.slice(0, 10)}</TableCell>
                            <TableCell>{row.createdBy}</TableCell>
                            <TableCell><IconButton  aria-label="Delete" onClick={event => this.handleDelete(event, row)}>
                                <DeleteIcon style={{cursor: 'pointer'}}/>
                            </IconButton></TableCell>
                        </TableRow>
                    );
                } else {
                    return (
                        <TableRow key={row._id}>
                            <TableCell style={{cursor: 'pointer'}} onClick={event => this.handleClick(event, row)}>{row.name}</TableCell>
                            <TableCell>{row.updatedAt.slice(0, 10)}</TableCell>
                            <TableCell>{row.createdBy}</TableCell>
                        </TableRow>
                    );
                }
            })
        }
    }

    handleClick = (event, row) => {
        this.props.handleSelect(row);
    };

    handleDelete = (event, row) => {
        this.props.handleDelete(row);
    };

    render() {
        const { classes } = this.props;
        if(this.props.showActions) {
            return (
                <Paper className={classes.root}>
                    <div className={classes.tableWrapper}>
                        <Table className={classes.table}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Rubric</TableCell>
                                    <TableCell>Created</TableCell>
                                    <TableCell>Created By</TableCell>
                                    <TableCell>Delete Rubric</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.renderRows(this.props.rubrics)}
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        colSpan={5}
                                        count={this.props.rubrics.length || 0}
                                        rowsPerPage={this.state.rowsPerPage}
                                        page={this.state.page}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        ActionsComponent={TablePaginationActionsWrapped}
                                    />
                                </TableRow>
                            </TableFooter>
                        </Table>
                    </div>
                </Paper>
            );
        } else {
            return (
                <Paper className={classes.root}>
                    <div className={classes.tableWrapper}>
                        <Table className={classes.table}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Rubric</TableCell>
                                    <TableCell>Modified</TableCell>
                                    <TableCell>Created By</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.renderRows(this.props.rubrics)}
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        colSpan={5}
                                        count={this.props.rubrics.length || 0}
                                        rowsPerPage={this.state.rowsPerPage}
                                        page={this.state.page}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        ActionsComponent={TablePaginationActionsWrapped}
                                    />
                                </TableRow>
                            </TableFooter>
                        </Table>
                    </div>
                </Paper>
            );
        }

    }
}

function mapStateToProps(state) {
    return {user: state.user, rubrics: state.rubricsList};
}

export default connect(mapStateToProps, actions)(withStyles(styles)(RubricsList));


